//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      machines: [],
    };
  },
  props: {
    accountId: {
      type: String,
      default: "",
    },
  },
  created() {
    this.getMachineList();
  },
  methods: {
    /**
     * @descripttion: 获取机具列表
     * @Author: juanjuanhui
     * @Date: 2021-11-23 14:04:06
     * @param {*}
     * @return {*}
     */
    getMachineList() {
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize, masterId: this.accountId };
      this.$http.basicInfo.getMachineList(params).then((res) => {
        let { recordTotal, content: machines } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.machines = machines;
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getMachineList();
    },
  },
};
